import React, { useState, useEffect } from "react";
import "@/App.css";
import { Menu, X, Star, ChevronDown, ChevronUp, Instagram, Phone, MapPin, ArrowLeft, ChevronLeft, ChevronRight } from "lucide-react";

// Asset URLs
const ASSETS = {
  homeVideo: "/hero-video.mp4",
  aboutPhoto: "https://customer-assets.emergentagent.com/job_about-photo-update/artifacts/0yu3bphz_IMG_2460.JPG",
  logo: "https://customer-assets.emergentagent.com/job_909ae8e4-3f32-4df0-a528-232a7340d6da/artifacts/g069zhfb_qt%3Dq_95.webp",
  actionVideo1: "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/150a07ih_D64C92CC-DC00-45D4-9016-0910C2DFB4C3.mp4",
  actionVideo2: "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/rns52c17_3E9FCA64-E1CC-49DF-BC2C-71840255EAB0.mp4",
  bridalBeauty: "https://customer-assets.emergentagent.com/job_form-integration-3/artifacts/pclk0n6z_IMG_0440.jpeg",
  editorial: "https://customer-assets.emergentagent.com/job_form-integration-3/artifacts/8egguem2_IMG_0472.jpg",
  specialEvents: "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/exf59hzx_IMG_0326.jpeg",
  groupBookings: "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/xtx9cnj0_Screenshot%202026-01-27%20at%209.22.38%E2%80%AFAM.png"
};

// Bridal / Milestone Beauties Gallery Images
const BRIDAL_GALLERY = [
  // Original images
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/rxtz7fxa_bridal%20beauty.jpeg",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/78xg3ehq_unnamed-1.jpg",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/eiged9ff_unnamed-1.png",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/5es2szxz_unnamed-2.jpg",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/1dulyo5b_unnamed-3.jpg",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/mz9sh4t5_unnamed-4.jpg",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/1s4jhcat_unnamed-5.jpg",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/lgzfz3bg_unnamed-6.jpg",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/67yysnh2_unnamed-7.jpg",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/pexwx8je_unnamed.jpg",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/tzy2vf1t_unnamed.png",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/jzfrk1o2_IMG_0214.jpeg",
  // New images from iCloud Photos zip file
  "/bridal/9601C497-BF8B-44BC-BD4E-E2A9C0E529B1.jpg",
  "/bridal/F389AC28-0E64-4C7D-8CF7-528CA872389C.JPG",
  "/bridal/IMG_0139.JPG",
  "/bridal/IMG_0215.JPG",
  "/bridal/IMG_0341.JPG",
  "/bridal/IMG_0489.JPG",
  "/bridal/IMG_0967.JPG",
  "/bridal/IMG_1842.PNG",
  "/bridal/IMG_1844.PNG",
  "/bridal/IMG_1883.JPG",
  "/bridal/IMG_1885.JPG",
  "/bridal/IMG_2699.JPG",
  "/bridal/IMG_2715.JPG",
  "/bridal/IMG_2718.JPG",
  "/bridal/IMG_2719.JPG",
  "/bridal/IMG_2753.JPG",
  "/bridal/IMG_3031.JPG",
  "/bridal/IMG_3120.JPG",
  "/bridal/IMG_3165.JPG",
  "/bridal/IMG_4085.JPG",
  "/bridal/IMG_4811.JPG",
  "/bridal/IMG_4820.JPG",
  "/bridal/IMG_5397.JPG",
  "/bridal/IMG_5499.JPG",
  "/bridal/IMG_5500.JPG",
  "/bridal/IMG_5544.JPG",
  "/bridal/IMG_5545.JPG",
  "/bridal/IMG_5772.JPG",
  "/bridal/IMG_5779.JPG",
  "/bridal/IMG_6603.jpeg",
  "/bridal/IMG_6604.jpeg",
  "/bridal/IMG_6675.jpeg",
  "/bridal/IMG_7771.JPG",
  "/bridal/IMG_7773.JPG",
  "/bridal/IMG_7775.JPG",
  "/bridal/IMG_7783.JPG",
  "/bridal/IMG_8382.jpg",
  "/bridal/IMG_8778.jpeg",
  "/bridal/IMG_8933.JPG",
  "/bridal/JR1_8094.JPG",
  "/bridal/JR1_8139.JPG",
  "/bridal/JR2_9453.JPG",
  "/bridal/Tezza-7213.JPG"
];

// Editorial / Productions Gallery Images
const EDITORIAL_GALLERY = [
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/oayo3h3e_IMG_0324.webp",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/exf59hzx_IMG_0326.jpeg"
];

// Runway Gallery Images - all runway photos
const RUNWAY_GALLERY = [
  // Original 5
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/ds85k7oi_IMG_0081.JPG",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/ez8psfnl_IMG_0083.JPG",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/1sat4cta_IMG_0340.JPG",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/jeqqctz6_IMG_0342.JPG",
  "https://customer-assets.emergentagent.com/job_jartistry-makeup/artifacts/jf0lwmrt_IMG_0348.JPG",
  // Additional runway photos from local folder
  "/runway/IMG_0349.JPG",
  "/runway/IMG_4411.JPG",
  "/runway/IMG_4412.JPEG",
  "/runway/IMG_4418.JPG",
  "/runway/IMG_4419.JPG",
  "/runway/IMG_4421.JPG",
  "/runway/IMG_4424.JPG",
  "/runway/IMG_4426.JPG",
  "/runway/IMG_5246.JPG",
  "/runway/IMG_5247.JPG",
  "/runway/IMG_5248.JPG",
  "/runway/IMG_5251.JPG",
  "/runway/IMG_5253.JPG",
  "/runway/IMG_5254.JPG",
  "/runway/IMG_5256.JPG",
  "/runway/IMG_5317.JPG",
  "/runway/IMG_5319.JPG",
  "/runway/IMG_5320.JPG",
  "/runway/IMG_5321.JPG",
  "/runway/IMG_5435.JPG",
  "/runway/IMG_5437.JPG",
  "/runway/IMG_5438.JPG",
  "/runway/IMG_5440.JPG",
  "/runway/IMG_5441.JPG",
  "/runway/IMG_5443.JPG",
  "/runway/IMG_5456.JPG",
  "/runway/IMG_5457.JPG",
  "/runway/IMG_5459.JPG",
  "/runway/IMG_5615.JPG",
  "/runway/IMG_5617.JPG",
  "/runway/IMG_5618.JPG",
  "/runway/IMG_5619.JPG",
  "/runway/IMG_5623.JPG",
  "/runway/IMG_5625.JPG",
  "/runway/IMG_5626.JPG",
  "/runway/IMG_5628.JPG",
  "/runway/IMG_5629.JPG",
  "/runway/IMG_7609.JPG",
  "/runway/IMG_7731.JPG",
  "/runway/IMG_7732.JPG",
  "/runway/IMG_7734.JPG",
  "/runway/IMG_7735.JPG",
  "/runway/IMG_7736.JPG",
  "/runway/IMG_7737.JPG",
  "/runway/IMG_7738.JPG",
  "/runway/IMG_7739.JPG",
  "/runway/IMG_7740.JPG",
  "/runway/IMG_7741.JPG",
  "/runway/IMG_7743.JPG",
  "/runway/IMG_7744.JPG",
  "/runway/IMG_7745.JPG",
  "/runway/IMG_7748.JPG",
  "/runway/IMG_7755.JPG",
  "/runway/IMG_7758.JPG",
  "/runway/IMG_7764.JPG",
  "/runway/IMG_7765.JPG",
  "/runway/IMG_7769.JPG",
  "/runway/IMG_7770.JPG",
  "/runway/IMG_7771.JPG",
  "/runway/IMG_7772.JPG",
  "/runway/IMG_7774.JPG",
  "/runway/IMG_7776.JPG",
  "/runway/IMG_7777.JPG",
  "/runway/IMG_7778.JPG",
  "/runway/IMG_7779.JPG",
  "/runway/IMG_7780.JPG",
  "/runway/IMG_7781.JPG",
  "/runway/IMG_7782.JPG",
  "/runway/IMG_7783.JPG",
  "/runway/IMG_9123.JPG",
  "/runway/IMG_9128.JPG"
];

// Navigation Component
const Navigation = ({ onOpenGallery }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isPortfolioOpen, setIsPortfolioOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { href: "#home", label: "Home" },
    { href: "#about", label: "About Me" },
    { href: "#services", label: "Services" },
    { href: "#action", label: "In Action" },
    { href: "#testimonials", label: "Testimonials" },
    { href: "#contact", label: "Contact" },
    { href: "#faq", label: "FAQ" },
  ];

  const portfolioItems = [
    { id: "bridal", label: "Bridal / Events" },
    { id: "runway", label: "Runway" },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
    setIsPortfolioOpen(false);
  };

  const handlePortfolioClick = (id) => {
    onOpenGallery(id);
    setIsPortfolioOpen(false);
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav className={`nav-container py-4 px-6 lg:px-12 ${isScrolled ? "nav-scrolled" : "bg-white/90 backdrop-blur-sm"}`} data-testid="main-navigation">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo */}
          <a href="#home" onClick={(e) => scrollToSection(e, "#home")} className="flex items-center gap-3" data-testid="logo-link">
            <img src={ASSETS.logo} alt="J-Artistry Logo" className="h-16 md:h-20 w-auto" />
            <span className="text-2xl md:text-3xl font-semibold tracking-wide text-gold-gradient" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              j-artistry
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.slice(0, 3).map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="nav-link text-sm uppercase tracking-widest text-gray-700 hover:text-[#c9a961] transition-colors"
                data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </a>
            ))}
            
            {/* Portfolio Dropdown */}
            <div className="relative">
              <button
                onClick={() => setIsPortfolioOpen(!isPortfolioOpen)}
                className="nav-link text-sm uppercase tracking-widest text-gray-700 hover:text-[#c9a961] transition-colors flex items-center gap-1"
                data-testid="nav-portfolio"
              >
                Portfolio
                <ChevronDown size={16} className={`transition-transform ${isPortfolioOpen ? "rotate-180" : ""}`} />
              </button>
              
              {isPortfolioOpen && (
                <div className="absolute top-full left-0 mt-2 bg-white shadow-xl border border-gray-100 min-w-[220px] z-50">
                  {portfolioItems.map((item) => (
                    <button
                      key={item.id}
                      onClick={() => handlePortfolioClick(item.id)}
                      className="block w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#c9a961] transition-colors"
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {navLinks.slice(3).map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="nav-link text-sm uppercase tracking-widest text-gray-700 hover:text-[#c9a961] transition-colors"
                data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(true)}
            data-testid="mobile-menu-button"
            aria-label="Open menu"
          >
            <Menu size={28} />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
      <div className="mobile-menu" data-testid="mobile-menu">
        <div className="p-6 flex justify-between items-center border-b border-gray-200">
          <span className="text-xl text-gold-gradient" style={{ fontFamily: "'Cormorant Garamond', serif" }}>j-artistry</span>
          <button onClick={() => setIsMobileMenuOpen(false)} className="text-gray-700" aria-label="Close menu">
            <X size={28} />
          </button>
        </div>
        <div className="flex flex-col items-center justify-center h-[calc(100vh-80px)] gap-6 overflow-y-auto py-8">
          {navLinks.slice(0, 3).map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className="text-xl uppercase tracking-widest text-gray-700 hover:text-[#c9a961] transition-colors"
            >
              {link.label}
            </a>
          ))}
          
          {/* Mobile Portfolio */}
          <div className="text-center">
            <p className="text-xl uppercase tracking-widest text-gray-700 mb-3">Portfolio</p>
            <div className="flex flex-col gap-2">
              {portfolioItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handlePortfolioClick(item.id)}
                  className="text-base text-gray-500 hover:text-[#c9a961] transition-colors"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {navLinks.slice(3).map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className="text-xl uppercase tracking-widest text-gray-700 hover:text-[#c9a961] transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
      )}
    </>
  );
};

// Hero Section
const HeroSection = () => {
  return (
    <section id="home" className="relative h-screen hero-section-large flex items-center justify-center overflow-hidden bg-black" data-testid="hero-section">
      <video
        autoPlay
        muted
        loop
        playsInline
        className="hero-video hero-video-desktop-shift"
      >
        <source src={ASSETS.homeVideo} type="video/mp4" />
      </video>
      <div className="video-overlay"></div>
      
      <div className="relative z-10 text-center px-6 max-w-4xl animate-fade-in-up">
        <h1 className="text-5xl md:text-7xl lg:text-8xl mb-6 text-white" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          J-Artistry
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-4 tracking-wide">
          Professional Makeup Artistry
        </p>
        <p className="text-lg md:text-xl text-white/90 mb-8 font-bold italic">
          "Take a seat in my chair, and let's make your moment unforgettable."
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#contact" className="btn-gold" data-testid="hero-book-btn">
            Book Your Session
          </a>
          <a href="#services" className="btn-outline-gold bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-[#c9a961]" data-testid="hero-services-btn">
            View Services
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-float">
        <ChevronDown className="text-white" size={32} />
      </div>
    </section>
  );
};

// About Section
const AboutSection = () => {
  return (
    <section id="about" className="section-padding bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="image-zoom">
              <img
                src={ASSETS.aboutPhoto}
                alt="J-Artistry - Professional Makeup Artist"
                className="w-full h-auto shadow-xl"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 border-2 border-[#c9a961] -z-10"></div>
          </div>

          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-gold-gradient mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              About Me
            </h2>
            <div className="section-divider section-divider-left"></div>
            
            <div className="mt-8 space-y-6">
              <p className="text-gray-700 text-base md:text-lg leading-relaxed">
                Hello beautiful, I'm Josehan Avila, a professional makeup artist and hairstylist and the artist behind J_Artistry. I've dedicated my life to becoming well-rounded in every aspect of beauty, allowing me to work confidently across bridal, red carpet, film, television, and special events.
              </p>
              
              <p className="text-gray-700 text-base md:text-lg leading-relaxed">
                My approach is always centered around you—your vision, your comfort, and how you want to feel. Whether you're walking down the aisle, stepping onto a red carpet, or in front of the camera, my goal is to create a timeless look while providing a warm, calming, and truly special experience.
              </p>
              
              {/* Behind the Glam */}
              <div className="mt-8 pt-6 border-t border-gray-200">
                <h3 className="text-2xl text-[#a68a3a] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Behind the Glam
                </h3>
                <ul className="space-y-2 text-gray-700 text-base md:text-lg">
                  <li className="flex items-start gap-2">
                    <span className="text-[#c9a961] mt-1">✦</span>
                    <span>16+ years of makeup experience</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#c9a961] mt-1">✦</span>
                    <span>300+ weddings served with excellence</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#c9a961] mt-1">✦</span>
                    <span>150+ Quinceañeras — elevated</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#c9a961] mt-1">✦</span>
                    <span>Multiple New York Fashion Week runway seasons</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#c9a961] mt-1">✦</span>
                    <span>Productions with Jennifer Lopez, Normani, Jordan Fisher, Blippi & Meekah</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#c9a961] mt-1">✦</span>
                    <span>Campaigns with GUCCI, Sunday Riley, Starbucks, and many more</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#c9a961] mt-1">✦</span>
                    <span>Worked with networks such as Disney, Netflix, Telemundo, Moonbug, and more</span>
                  </li>
                </ul>
              </div>
              
              <p className="text-[#a68a3a] text-lg md:text-xl italic font-medium leading-relaxed" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                "Bringing inner beauty to the surface with the blend of a brush"
                <span className="block text-base mt-2 not-italic text-gray-600">— Josehan Avila</span>
              </p>
            </div>

            <a href="#contact" className="btn-gold inline-block mt-8" data-testid="about-cta-btn">
              Work With Me
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

// Gallery Component
const GalleryView = ({ galleryType, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryConfig = {
    bridal: {
      title: "Bridal / Events",
      images: BRIDAL_GALLERY,
      bookLabel: "Book Bridal Services"
    },
    runway: {
      title: "Runway",
      images: RUNWAY_GALLERY,
      bookLabel: "Book Runway Services"
    }
  };

  const config = galleryConfig[galleryType];
  if (!config) return null;

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % config.images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + config.images.length) % config.images.length);
  };

  const scrollToContact = () => {
    onClose();
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="fixed inset-0 z-50 bg-white" data-testid={`${galleryType}-gallery`}>
      {/* Header */}
      <div className="flex items-center justify-between p-6 border-b border-gray-200">
        <button
          onClick={onClose}
          className="flex items-center gap-2 text-gray-700 hover:text-[#c9a961] transition-colors"
          data-testid="gallery-back-btn"
        >
          <ArrowLeft size={24} />
          <span className="text-sm uppercase tracking-wider">Back</span>
        </button>
        <h2 className="text-2xl md:text-3xl text-gold-gradient" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          {config.title}
        </h2>
        <div className="w-24"></div>
      </div>

      {/* Main Image */}
      <div className="relative h-[calc(100vh-220px)] flex items-center justify-center p-4 md:p-8">
        <button
          onClick={prevImage}
          className="absolute left-2 md:left-4 z-10 p-2 md:p-3 bg-white/90 shadow-lg hover:bg-[#c9a961] hover:text-white transition-colors"
          aria-label="Previous image"
        >
          <ChevronLeft size={24} />
        </button>

        <img
          src={config.images[currentIndex]}
          alt={`${config.title} ${currentIndex + 1}`}
          className="max-h-full max-w-full object-contain shadow-2xl"
        />

        <button
          onClick={nextImage}
          className="absolute right-2 md:right-4 z-10 p-2 md:p-3 bg-white/90 shadow-lg hover:bg-[#c9a961] hover:text-white transition-colors"
          aria-label="Next image"
        >
          <ChevronRight size={24} />
        </button>
      </div>

      {/* Thumbnails */}
      <div className="flex justify-center gap-2 md:gap-3 p-4 bg-gray-50 overflow-x-auto">
        {config.images.map((img, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`flex-shrink-0 w-14 h-14 md:w-20 md:h-20 overflow-hidden border-2 transition-all ${
              currentIndex === index ? "border-[#c9a961] scale-110" : "border-transparent opacity-60 hover:opacity-100"
            }`}
          >
            <img src={img} alt={`Thumbnail ${index + 1}`} className="w-full h-full object-cover" />
          </button>
        ))}
      </div>

      {/* Book Button */}
      <div className="absolute bottom-28 left-1/2 -translate-x-1/2">
        <button onClick={scrollToContact} className="btn-gold">
          {config.bookLabel}
        </button>
      </div>
    </div>
  );
};

// Services Data (Updated - Bridal/Events and Editorial/Productions)
const servicesData = [
  {
    id: "bridal",
    title: "Bridal / Events",
    image: ASSETS.bridalBeauty,
    hasGallery: true,
    galleryType: "bridal",
    description: "Weddings, quinceañeras, and all of life's most beautiful moments deserve unforgettable glam.",
    included: [
      "Consultation to discuss your vision",
      "Full glam makeup tailored to your comfort",
      "Lash application included",
      "On-location services",
      "Bridal party & group services available"
    ],
    additional: [
      "Trial session (recommended 2–4 weeks before)",
      "Overtime touch-up services"
    ]
  },
  {
    id: "editorial",
    title: "Editorial & Productions",
    image: ASSETS.editorial,
    hasExternalLink: true,
    externalLink: "https://www.JosehanAvila.com",
    description: "J-Artistry provides professional makeup and hairstyling for editorial, campaigns, fashion, film, television, commercial, and digital productions. Each look is thoughtfully designed to align with the creative vision of the project—ranging from clean, modern beauty to bold, conceptual glam.",
    included: [
      "Pre-production consultation",
      "On-set hair and makeup services",
      "Quick change expertise",
      "Touch-ups throughout the production day",
      "Flexible scheduling for long shoots"
    ],
    additional: []
  }
];

// Services Section
const ServicesSection = ({ onOpenGallery }) => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="section-padding bg-gray-50" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl text-gold-gradient" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Services
          </h2>
          <div className="section-divider"></div>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4">
            Elevating your beauty for life's most memorable moments
          </p>
        </div>

        <div className="services-grid">
          {servicesData.map((service) => (
            <div
              key={service.id}
              className="service-card card-light overflow-hidden"
              data-testid={`service-${service.id}`}
            >
              {service.image && (
                <div className={`service-image-container cursor-pointer ${service.id === 'bridal' ? 'bridal-image' : ''}`} onClick={() => {
                  if (service.hasExternalLink) {
                    window.open(service.externalLink, '_blank', 'noopener,noreferrer');
                  } else if (service.hasGallery) {
                    onOpenGallery(service.galleryType);
                  } else {
                    scrollToContact();
                  }
                }}>
                  <img
                    src={service.image}
                    alt={service.title}
                    loading="lazy"
                  />
                  {service.hasGallery && (
                    <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                      <span className="text-white text-sm uppercase tracking-wider">View Gallery</span>
                    </div>
                  )}
                  {service.hasExternalLink && (
                    <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                      <span className="text-white text-sm uppercase tracking-wider">View Portfolio</span>
                    </div>
                  )}
                </div>
              )}
              
              <div className="p-6 lg:p-8">
                <h3 className="text-2xl text-[#a68a3a] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  {service.title}
                </h3>
                
                {service.description && (
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {service.description}
                  </p>
                )}

                <h4 className="text-xs uppercase tracking-wider text-gray-800 mb-3 font-semibold">What's Included:</h4>
                <ul className="includes-list text-gray-600 mb-4">
                  {service.included.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>

                {service.additional && service.additional.length > 0 && (
                  <>
                    <h4 className="text-xs uppercase tracking-wider text-gray-800 mb-3 mt-6 font-semibold">
                      Additional Services (Not Included):
                    </h4>
                    <ul className="includes-list text-gray-500">
                      {service.additional.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  </>
                )}

                {service.hasGallery ? (
                  <div className="flex gap-3 mt-6">
                    <button onClick={scrollToContact} className="btn-gold flex-1">
                      Book
                    </button>
                    <button onClick={() => onOpenGallery(service.galleryType)} className="btn-outline-gold flex-1">
                      Gallery
                    </button>
                  </div>
                ) : service.hasExternalLink ? (
                  <div className="flex gap-3 mt-6">
                    <button onClick={scrollToContact} className="btn-gold flex-1">
                      Book
                    </button>
                    <a 
                      href={service.externalLink} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="btn-outline-gold flex-1 text-center"
                    >
                      Portfolio
                    </a>
                  </div>
                ) : (
                  <button onClick={scrollToContact} className="btn-gold mt-6 w-full">
                    Book This Service
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// In Action Section - Vertical Videos
const InActionSection = () => {
  return (
    <section id="action" className="section-padding bg-white" data-testid="action-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl text-gold-gradient" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            In Action
          </h2>
          <div className="section-divider"></div>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4">
            Watch the transformation unfold
          </p>
        </div>

        <div className="action-videos">
          <div className="action-video-container">
            <div className="relative aspect-[9/16] bg-gray-100 rounded-lg overflow-hidden shadow-xl">
              <video
                controls
                playsInline
                preload="metadata"
                className="w-full h-full object-cover"
                data-testid="action-video-1"
              >
                <source src={ASSETS.actionVideo1} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div className="action-video-container">
            <div className="relative aspect-[9/16] bg-gray-100 rounded-lg overflow-hidden shadow-xl">
              <video
                controls
                playsInline
                preload="metadata"
                className="w-full h-full object-cover"
                data-testid="action-video-2"
              >
                <source src={ASSETS.actionVideo2} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Testimonials Data
const testimonialsData = [
  {
    id: 1,
    name: "Benita North",
    rating: 5,
    text: "A remarkably talented makeup artist who has honed his craft. With every experience I am left speechless and my makeup is flawless. I highly recommend Mr. Avila."
  },
  {
    id: 2,
    name: "Mariann",
    rating: 5,
    text: "I love Josehan and his Team! They all do an amazing job and they all make sure that the client feels beautiful!"
  },
  {
    id: 3,
    name: "Stacy Al-nahdy",
    rating: 5,
    text: "I will never get over the level of quality and professionalism that Josehan and his team delivered for my wedding. They were on time, attentive, worked efficiently and produced the exact look I asked for. I will always be grateful for the part he played in making my dreams come true. He was worth every penny and then some! If you haven't already, BOOK HIM! Thanks so much Josehan."
  }
];

// Testimonials Section
const TestimonialsSection = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastInitial: "",
    cityState: "",
    starRating: 5,
    testimonialText: "",
    photo: null
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = e.target;
    const data = new FormData(form);

    try {
      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data).toString()
      });

      if (response.ok) {
        setSubmitSuccess(true);
        setFormData({
          firstName: "",
          lastInitial: "",
          cityState: "",
          starRating: 5,
          testimonialText: "",
          photo: null
        });
      }
    } catch (error) {
      console.error("Error submitting testimonial:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="testimonials" className="section-padding bg-gray-50" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl text-gold-gradient" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Client Love
          </h2>
          <div className="section-divider"></div>
          <p className="text-gray-600 max-w-3xl mx-auto mt-4 text-lg">
            What my Beauties have to say about their J-Artistry Experience
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="testimonials-grid mb-12">
          {testimonialsData.map((testimonial) => (
            <div
              key={testimonial.id}
              className="testimonial-card card-light p-8 relative"
              data-testid={`testimonial-${testimonial.id}`}
            >
              <div className="star-rating mb-4 relative z-10">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="star w-5 h-5 fill-current" />
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed relative z-10">
                {testimonial.text}
              </p>
              <div className="relative z-10">
                <p className="text-[#a68a3a] font-semibold">— {testimonial.name}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Submit Testimonial */}
        <div className="text-center">
          {!showForm ? (
            <button
              onClick={() => setShowForm(true)}
              className="btn-outline-gold"
              data-testid="submit-testimonial-btn"
            >
              Share Your Experience
            </button>
          ) : (
            <div className="max-w-xl mx-auto card-light p-8">
              {submitSuccess ? (
                <div className="form-success" data-testid="testimonial-success">
                  <h3>Thank You!</h3>
                  <p className="text-gray-600">Your testimonial has been submitted successfully.</p>
                  <button
                    onClick={() => {
                      setShowForm(false);
                      setSubmitSuccess(false);
                    }}
                    className="btn-outline-gold mt-6"
                  >
                    Close
                  </button>
                </div>
              ) : (
                <form
                  name="testimonial"
                  method="POST"
                  data-netlify="true"
                  netlify-honeypot="bot-field"
                  onSubmit={handleSubmit}
                  className="contact-form-light"
                  data-testid="testimonial-form"
                >
                  <input type="hidden" name="form-name" value="testimonial" />
                  <p className="hidden">
                    <label>Don't fill this out: <input name="bot-field" /></label>
                  </p>

                  <h3 className="text-2xl text-[#a68a3a] mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                    Share Your Experience
                  </h3>

                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label>First Name</label>
                      <input
                        type="text"
                        name="firstName"
                        required
                        value={formData.firstName}
                        onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                        data-testid="testimonial-firstname"
                      />
                    </div>
                    <div>
                      <label>Last Initial</label>
                      <input
                        type="text"
                        name="lastInitial"
                        maxLength={1}
                        required
                        value={formData.lastInitial}
                        onChange={(e) => setFormData({ ...formData, lastInitial: e.target.value })}
                        data-testid="testimonial-lastinitial"
                      />
                    </div>
                  </div>

                  <div className="mb-4">
                    <label>City and State</label>
                    <input
                      type="text"
                      name="cityState"
                      required
                      value={formData.cityState}
                      onChange={(e) => setFormData({ ...formData, cityState: e.target.value })}
                      placeholder="e.g., Miami, FL"
                      data-testid="testimonial-citystate"
                    />
                  </div>

                  <div className="mb-4">
                    <label>Star Rating</label>
                    <div className="star-input mt-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button
                          key={star}
                          type="button"
                          className={formData.starRating >= star ? "active" : ""}
                          onClick={() => setFormData({ ...formData, starRating: star })}
                        >
                          <Star className={formData.starRating >= star ? "fill-current text-[#c9a961]" : ""} />
                        </button>
                      ))}
                    </div>
                    <input type="hidden" name="starRating" value={formData.starRating} />
                  </div>

                  <div className="mb-4">
                    <label>Your Testimonial</label>
                    <textarea
                      name="testimonialText"
                      rows={4}
                      required
                      value={formData.testimonialText}
                      onChange={(e) => setFormData({ ...formData, testimonialText: e.target.value })}
                      placeholder="Share your J-Artistry experience..."
                      data-testid="testimonial-text"
                    />
                  </div>

                  <div className="mb-6">
                    <label>Photo (Optional)</label>
                    <input
                      type="file"
                      name="photo"
                      accept="image/*"
                      className="w-full p-3 bg-white border border-gray-200 text-gray-600"
                      onChange={(e) => setFormData({ ...formData, photo: e.target.files[0] })}
                      data-testid="testimonial-photo"
                    />
                  </div>

                  <div className="flex gap-4">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn-gold flex-1"
                      data-testid="testimonial-submit-btn"
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                    <button
                      type="button"
                      onClick={() => setShowForm(false)}
                      className="btn-outline-gold"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

// FAQ Data
const faqData = [
  {
    question: "How far in advance should I book?",
    answer: "As soon as you get a date — I'm currently getting booked about 1–2 years out."
  },
  {
    question: "Do you offer trials?",
    answer: "Yes! I highly recommend a trial session, especially for bridal clients. Trials are typically scheduled 2-4 weeks before your event date to ensure we perfect your look."
  },
  {
    question: "Do you travel for events?",
    answer: "Absolutely! I offer on-location services and am available to travel for destination weddings and events. Travel fees may apply depending on location."
  },
  {
    question: "What is your cancellation policy?",
    answer: "In the event that the artist must cancel on the client, a full refund of the deposit will be provided. Client cancellations are subject to the terms outlined in your service agreement, which includes deposit forfeiture for cancellations within 30 days of the event date."
  },
  {
    question: "Can you accommodate large bridal parties?",
    answer: "Yes! I can accommodate bridal parties of any size. For larger groups, I may bring additional artists to ensure everyone is ready on time."
  },
  {
    question: "What products do you use?",
    answer: "I use a combination of high-end, professional-grade products from brands like Charlotte Tilbury, Pat McGrath, NARS, and more. All products are selected for their quality, longevity, and photography-ready finish."
  }
];

// FAQ Section
const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="section-padding bg-white" data-testid="faq-section">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl text-gold-gradient" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            FAQ
          </h2>
          <div className="section-divider"></div>
        </div>

        <div className="space-y-0">
          {faqData.map((faq, index) => (
            <div key={index} className="faq-item py-6" data-testid={`faq-${index}`}>
              <button
                className="w-full flex items-center justify-between text-left"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                aria-expanded={openIndex === index}
              >
                <span className="faq-question text-lg text-gray-800 pr-4">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="text-[#c9a961] flex-shrink-0" size={24} />
                ) : (
                  <ChevronDown className="text-[#c9a961] flex-shrink-0" size={24} />
                )}
              </button>
              {openIndex === index && (
                <p className="faq-answer mt-4 pl-0 animate-fade-in">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Contact Section with HoneyBook Widget
const ContactSection = () => {
  useEffect(() => {
    // Load HoneyBook widget script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://widget.honeybook.com/assets_users_production/websiteplacements/placement-controller.min.js';
    
    // Set HoneyBook configuration
    window._HB_ = window._HB_ || {};
    window._HB_.pid = '6984d06805561300338be929';
    
    document.body.appendChild(script);
    
    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="contact" className="section-padding bg-gray-50" data-testid="contact-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl text-gold-gradient" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Let's Connect
          </h2>
          <div className="section-divider"></div>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4">
            Ready to elevate your beauty? Fill out the form below and let's create something beautiful together.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-12">
          {/* HoneyBook Widget - Shows first on mobile, second on desktop */}
          <div className="lg:col-span-2 order-1 lg:order-2">
            <div className="card-light p-8 min-h-[500px]" data-testid="honeybook-widget-container">
              <div className="hb-p-6984d06805561300338be929-2"></div>
              <img 
                height="1" 
                width="1" 
                style={{ display: 'none' }} 
                src="https://www.honeybook.com/p.png?pid=6984d06805561300338be929" 
                alt=""
              />
            </div>
          </div>

          {/* Contact Info - Shows second on mobile, first on desktop */}
          <div className="lg:col-span-1 order-2 lg:order-1">
            <div className="contact-info-box p-8 h-full">
              <h3 className="text-2xl text-white mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Get in Touch
              </h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <Phone className="text-white/80 mt-1" size={20} />
                  <div>
                    <p className="text-white/60 text-sm uppercase tracking-wider mb-1">Phone</p>
                    <a href="tel:+12394105097" className="text-white hover:opacity-80 transition-opacity">
                      (239) 410-5097
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <Instagram className="text-white/80 mt-1" size={20} />
                  <div>
                    <p className="text-white/60 text-sm uppercase tracking-wider mb-1">Instagram</p>
                    <a href="https://instagram.com/j_artistry__" target="_blank" rel="noopener noreferrer" className="text-white hover:opacity-80 transition-opacity">
                      @j_artistry__
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <MapPin className="text-white/80 mt-1" size={20} />
                  <div>
                    <p className="text-white/60 text-sm uppercase tracking-wider mb-1">Service Area</p>
                    <p className="text-white">South Florida</p>
                    <p className="text-white/80 text-sm mt-1">Naples • Fort Myers • Miami & beyond</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-white/20">
                <p className="text-white/60 text-sm uppercase tracking-wider mb-4">Follow Along</p>
                <div className="flex gap-4">
                  <a
                    href="https://instagram.com/j_artistry__"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:opacity-80 transition-opacity"
                    aria-label="Instagram"
                  >
                    <Instagram size={24} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-8 px-6 bg-white border-t border-gray-200" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src={ASSETS.logo} alt="J-Artistry Logo" className="h-10 w-auto" />
            <span className="text-lg text-gold-gradient" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              j-artistry
            </span>
          </div>
          
          <p className="text-gray-500 text-sm">
            © {currentYear} J-Artistry. All rights reserved.
          </p>

          <div className="flex gap-4">
            <a
              href="https://instagram.com/j_artistry__"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#c9a961] transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Main App Component
function App() {
  const [activeGallery, setActiveGallery] = useState(null);

  const openGallery = (galleryType) => {
    setActiveGallery(galleryType);
    window.scrollTo(0, 0);
  };

  const closeGallery = () => {
    setActiveGallery(null);
  };

  return (
    <div className="App">
      {activeGallery ? (
        <GalleryView galleryType={activeGallery} onClose={closeGallery} />
      ) : (
        <>
          <Navigation onOpenGallery={openGallery} />
          <main>
            <HeroSection />
            <AboutSection />
            <ServicesSection onOpenGallery={openGallery} />
            <InActionSection />
            <TestimonialsSection />
            <ContactSection />
            <FAQSection />
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
